import { useState } from "react";
import Nav from "./Nav";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addCustomer } from "./api";

const Addcustomer = () => {
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [area, setArea] = useState("");

  const queryClient = useQueryClient();

  // Mutation hook
  const mutation = useMutation({
    mutationFn: addCustomer,
    onSuccess: () => {
      // Reset form
      setMobile("");
      setArea("");
      setName("");
      alert("Customer stored successfully ✅");

      // If you have a customer list query, refresh it:
      queryClient.invalidateQueries(["customers"]);
    },
    onError: () => {
      alert("❌ Failed to store customer");
    },
  });

  const submitdata = () => {
    if (!name.trim() || !area.trim()) {
      alert("Please fill all fields before submitting.");
      return;
    }

    const value = {
      name: name.trim(),
      mobile: mobile.trim(),
      area: area.trim(),
    };

    mutation.mutate(value);
  };

  return (
    <>
      <Nav />
      <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
        <div
          className="card shadow p-4"
          style={{ width: "100%", maxWidth: "450px" }}
        >
          <h3 className="text-center text-primary mb-4 fw-bold">
            ➕ Add Customer
          </h3>

          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="name"
              onChange={(e) => setName(e.target.value)}
              value={name}
              placeholder="Enter Name"
            />
            <label htmlFor="name">Name</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="mobile"
              onChange={(e) => setMobile(e.target.value)}
              value={mobile}
              placeholder="Enter Mobile"
            />
            <label htmlFor="mobile">Mobile</label>
          </div>

          <div className="form-floating mb-4">
            <input
              type="text"
              className="form-control"
              id="area"
              onChange={(e) => setArea(e.target.value)}
              value={area}
              placeholder="Enter Area"
            />
            <label htmlFor="area">Area</label>
          </div>

          <button
            className="btn btn-success w-100 rounded-pill"
            onClick={submitdata}
            disabled={mutation.isLoading} // disable while submitting
          >
            {mutation.isLoading ? "Saving..." : "✅ Save Customer"}
          </button>
        </div>
      </div>
    </>
  );
};

export default Addcustomer;
